import {
  REQUEST_APP_INITIALIZER,
  APP_INITIALIZER_FAILURE,
  RECEIVE_SELECTOR_VALS,
  FIELD_NOT_FOUND_FAILURE,
} from '../constants/actionTypes';

export const initialState = {
  didError: false,
  hasFetched: false,
  isFetching: false,
};

/**
 * Handles redux state for app initializer data
 * @param {Object} state
 * @param {Object} action
 * @return {Object} new state
 */
function appInitializerReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_APP_INITIALIZER:
      return {
        ...state,
        hasFetched: false,
        isFetching: true,
      };
    case APP_INITIALIZER_FAILURE:
    case FIELD_NOT_FOUND_FAILURE:
      return {
        didError: true,
        hasFetched: true,
        isFetching: false,
      };
    case RECEIVE_SELECTOR_VALS:
      return {
        didError: false,
        hasFetched: true,
        isFetching: false,
      };
    default:
      return state;
  }
}

export default appInitializerReducer;
